<template>
    <div>
        <div v-if="order.refunds.length === 0 && !order.is_refunded">
            {{ __('payment.none_refunded') }}
        </div>

        <div v-if="order.refunds.length > 0" class="table-responsive">
            <table class="table table-hover table-vertical-center">
                <thead>
                <tr>
                    <th>RMA-ID</th>
                    <th>{{ __('general.article') }}</th>
                    <th>{{ __('general.quantity_refunded') }}</th>
                    <th>{{ __('general.reason') }}</th>
                    <th>{{ __('general.additional_info') }}</th>
                    <th class="text-right">{{ __('general.status') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="refund in order.refunds">
                    <td>
                        <div v-if="order.integration.code === IntegrationCodeEnum.AmazonMFN">
                            {{ refund.meta?.return_metadata?.rmaId }}
                        </div>
                        <div v-else class="text-muted">
                            n/a
                        </div>
                    </td>
                    <td>
                        {{ refund.identifier_type.toUpperCase() }}:&nbsp;
                        {{ refund.identifier }}</td>
                    <td>
                        {{ refund.quantity_refunded }}
                    </td>
                    <td>
                        <div v-if="[Integration.AmazonMFN, Integration.AmazonTODAY].includes(order.integration.code)">
                            {{ refund.meta?.return_metadata?.returnReason }}
                        </div>
                        <div v-else class="text-muted">
                            n/a
                        </div>
                    </td>
                    <td>
                        <div v-if="[Integration.AmazonMFN, Integration.AmazonTODAY].includes(order.integration.code)">
                            <div>
                                {{ __('sale.shipping') }}:&nbsp;
                                {{ refund.meta.return_shipping_info?.forwardTrackingInfo?.carrierName }}&nbsp;
                                ({{ refund.meta.return_shipping_info?.forwardTrackingInfo?.trackingId }})
                            </div>
                        </div>
                        <div v-else class="text-muted">
                            n/a
                        </div>
                    </td>
                    <td class="text-right">
                        <div v-if="refund.effective" class="text-success">
                            <i class="fas fa-check"/>
                            {{ __('orders.details.refund.done') }}
                        </div>
                        <div v-else>
                            <Badge>
                                {{ __('orders.details.refund.pending') }}
                            </Badge>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import Badge from "@components/Badge.vue";
import {IntegrationCodeEnum} from "@generated/integrationCodeEnum";

export default {
    computed: {
        IntegrationCodeEnum() {
            return IntegrationCodeEnum
        }
    },
    components: {Badge},

    props: {
        order: Object,
        userNames: {
            types: [Object, Array],
        },
    }
};
</script>
